export const firebase_config = {
    apiKey: "AIzaSyDHuwnaSTJ_7c4cKb6R3P09e22nBWIm5lY",
    authDomain: "hic-academy-dev.firebaseapp.com",
    projectId: "hic-academy-dev",
    storageBucket: "hic-academy-dev.appspot.com",
    messagingSenderId: "968821984209",
    appId: "1:968821984209:web:e07ca1189e67efc70aaef0",
    measurementId: "G-LNSEQKGBHL"
};
